import { render, staticRenderFns } from "./news-board.vue?vue&type=template&id=852d4880&"
import script from "./news-board.vue?vue&type=script&lang=js&"
export * from "./news-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports